export default "__VITE_ASSET__CwFmQphU__"